import React from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { setLenguageData } from '@/redux/actions/lenguageDataActions';
import { setCurrency } from '@/redux/actions/currencyActions';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../Footer.scss';

const Footer = () => {
  const lenguageData = useSelector((state) => state.lenguage?.lang);
  const currencyData = useSelector(state => state.currency?.currency);
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();

  const changeLanguage = () => {
    dispatch(
      setLenguageData({
        lang: lenguageData === 'EN' ? 'ES' : 'EN',
        isButton: true,
      }),
    );
  };

  const changeCurrency = () => {
    dispatch(
      setCurrency({
        currency: currencyData === 'USD' ? 'MXN' : 'USD',
        isButton: true,
      }),
    );
  };
  return (
    <FlexContainer
      className={'footer-popnest flex-column padt20 padb60 padlr130 m-padlr20'}
      justifyBetween
      alignItemsStart
    >
      <FlexContainer className={'m-flex-column width100 margt20'}>
        <FlexContainer className={'flex-column format100'}>
          <img
            src="/Logotipo_P_Blanco.png"
            alt="Popnest"
            style={{ width: '35%', cursor: 'pointer' }}
          />
          <FlexContainer className={'width100'}>
            <a
              href="https://www.facebook.com/popnestmexico"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f fontWhite text-18 margl10" />
            </a>
            <a
              href="https://www.tiktok.com/@popnest.connect"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-tiktok fontWhite text-18 margl10" />
            </a>
            <a
              href="https://www.instagram.com/popnest_connect/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fontWhite text-18 margl10" />
            </a>
            <a
              href="https://www.linkedin.com/company/popnest/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in fontWhite text-18 margl10" />
            </a>
          </FlexContainer>
          <p className={'fontWhite margt20 text-12 padlr8'}>
            {lenguageData === 'ES'
              ? 'Somos un equipo de apasionados por la innovación y el buen vivir. Ofrecemos espacios de trabajo únicos, con privacidad, buen diseño y sin ruido.'
              : "We're passionate about innovation and modern living. Popnest offers unique workspaces with privacy, great design, and a quiet atmosphere."}
          </p>
        </FlexContainer>
        <FlexContainer className={'flex-column padlr8 format100 m-formatAuto'}>
          <ul className={'fontWhite text-12'} style={{ listStyleType: 'none', padding: 0 }}>
            <li className={'margb20'}>
              <Link to="/" className={'fontWhite'} style={{ textDecoration: 'none' }}>
                {lenguageData === 'ES' ? <strong>INICIO</strong> : <strong>HOME</strong>}
              </Link>
            </li>
            {/*
            <li className={'margb20'}>
              <Link
                to={lenguageData === 'ES' ? '/espacios' : '/spaces'}
                className={'fontWhite'}
                style={{ textDecoration: 'none' }}
              >
                {lenguageData === 'ES' ? <strong>ESPACIOS</strong> : <strong>PLACES</strong>}
              </Link>
            </li>
            */}
            <li className={'margb20'}>
              <Link
                to={lenguageData === 'ES' ? '/blog-popnest' : '/blog'}
                className={'fontWhite'}
                style={{ textDecoration: 'none' }}
              >
                {lenguageData === 'ES' ? <strong>BLOG</strong> : <strong>BLOG</strong>}
              </Link>
            </li>
          </ul>
        </FlexContainer>
        <FlexContainer className={'flex-column padlr8 format100 m-formatAuto'}>
          <ul className={'fontWhite text-12'} style={{ listStyleType: 'none', padding: 0 }}>
            {/*
              <li className={'margb20'}>
                <Link to="/" className={'fontWhite'} style={{ textDecoration: 'none' }}>
                  {lenguageData === 'ES' ? <strong>Mi Perfil</strong> : <strong>My Profile</strong>}
                </Link>
              </li>
              */}
            <li className={'margb20'}>
              <Link
                to={lenguageData === 'ES' ? '/terminos-condiciones' : '/terms-conditions'}
                className={'fontWhite'}
                style={{ textDecoration: 'none' }}
              >
                {lenguageData === 'ES' ? (
                  <strong>TÉRMINOS Y CONDICIONES</strong>
                ) : (
                  <strong>TERMS AND CONDITIONS</strong>
                )}
              </Link>
            </li>
          </ul>
        </FlexContainer>
        <FlexContainer className={'flex-column padlr8 format100 m-formatAuto'}>
          <ul className={'fontWhite text-12'} style={{ listStyleType: 'none', padding: 0 }}>
            {/*
              <li className={'margb20'}>
                <Link to="/" className={'fontWhite'} style={{ textDecoration: 'none' }}>
                  {lenguageData === 'ES' ? <strong>Mi Perfil</strong> : <strong>My Profile</strong>}
                </Link>
              </li>
              */}
            <li className={'margb20'}>
              <Link
                to={lenguageData === 'ES' ? '/politica-privacidad' : '/privacy-policy'}
                className={'fontWhite'}
                style={{ textDecoration: 'none' }}
              >
                {lenguageData === 'ES' ? (
                  <strong> AVISO DE PRIVACIDAD</strong>
                ) : (
                  <strong>PRIVACY NOTICE</strong>
                )}
              </Link>
            </li>
            <li className={'margb20'}>
              <button
                type="button"
                onClick={changeLanguage}
                className={'bgTransparent borderNone fontWhite text-12 pointer'}
                style={{ textDecoration: 'none', padding: 0 }}
              >
                <strong>
                  {lenguageData === 'EN'
                    ? '🇲🇽 CAMBIAR A ESPAÑOL'
                    : '🇺🇸 SWITCH TO ENGLISH'}
                </strong>
              </button>
            </li>
            <li className={'margb20'}>
              <button
                type="button"
                onClick={changeCurrency}
                className={'bgTransparent borderNone fontWhite text-12 pointer'}
                style={{ textDecoration: 'none', padding: 0 }}
              >
                <strong>{currencyData === 'MXN' ? '💲 MXN' : '💲 USD'}</strong>
              </button>
            </li>
          </ul>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className={'width100 margt60'}>
        <Label className={'text-10 m-text-8 fontWhite margt8 padlr8'}>
          {lenguageData === 'ES'
            ? `Copyright © ${currentYear} Finovix Sapi de CV. Todos los derechos reservados.`
            : `Copyright © ${currentYear} Finovix SAPI de CV. All rights reserved.`}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default Footer;
